import { NavLink } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import cn from 'classnames'

import userIng from '@src/images/user.svg'
import style from '@src/components/IndividualsPanel/IndividualsPanel.module.scss'
import { AppDispatch } from '@src/store/store'
import { logout } from '@src/store/ducks/auth/thunks'
import {
  selectUserInfo,
  selectUserServices,
  selectUserUnreadMessages,
} from '@src/store/ducks/user/selectors'
import { ReactComponent as Exit } from '@src/images/exit.svg'

export const IndividualsPanel = () => {
  const dispatch = useDispatch<AppDispatch>()
  const user = useSelector(selectUserInfo)
  const countUnreadMessages = useSelector(selectUserUnreadMessages)
  // const countUnreadMessages = () => messagesArr.filter((message) => !message.isRead).length

  const { tariff } = useSelector(selectUserServices)
  const formatNumber = (number: number) => {
    if (number >= 1000) {
      return `${(number / 1000).toFixed(1)}k`
    }
    return number
  }
  return (
    <nav className={style.individual_panel}>
      <div className={cn(style.container, 'container')}>
        <div className={style.ind_nav}>
          <div className={style.user_block}>
            <NavLink
              to="/"
            >
              <img src={userIng} alt="logo user" />
              <span>{user.username}</span>
            </NavLink>
          </div>

          <NavLink activeClassName={style.activeMenu} to="/my-profile" className={style.ind_item}>
            Мой профиль
          </NavLink>
          <NavLink activeClassName={style.activeMenu} to="/payments" className={style.ind_item}>
            История платежей
          </NavLink>
          <NavLink activeClassName={cn(style.activeMenu)} to="/messages" className={cn(style.ind_item, style.ind_item_mgs)}>
            Сообщения
            {countUnreadMessages > 0 ? (
              <i className={style.ind_item_mgs_icon} data-count="0">
                +
                {formatNumber(countUnreadMessages)}
              </i>
            ) : null}
          </NavLink>
          {!!tariff.length && !user.isSubscriber && (
            <NavLink
              activeClassName={style.activeMenu}
              to={`/additional-services/${tariff[0].serviceId}`}
              className={style.ind_item}
            >
              Дополнительные услуги
            </NavLink>
          )}
        </div>

        <button type="button" onClick={() => { dispatch(logout()) }} className={style.user_area}>
          <Exit />
          Выйти из аккаунта
        </button>

      </div>
    </nav>
  )
}
